import { withDependencies } from '@wix/thunderbolt-ioc'
import type { EsModuleShimsRuntimeState } from './types'

export const EsModuleShimsRuntimeStateFactory = withDependencies([], (): EsModuleShimsRuntimeState => {
	let enabled = false

	return {
		isEnabled: () => enabled,
		setIsEnabled: (value: boolean) => {
			enabled = value
		},
	}
})
